/**
 * Default trip checklist template helpers — mirrors iOS TripTaskListService.
 */

import type { TripTaskItem } from '../types/client';
import {
  loadLocalUserPreferences,
  patchTravelerPreferenceProfile,
  type TripTaskTemplateItem,
} from '../services/userPreferencesSyncService';
import { DEFAULT_TRIP_TASK_SEED_TITLES } from './travelerPreferenceOptions';

export function seedDefaultTripTaskTemplate(): TripTaskTemplateItem[] {
  return DEFAULT_TRIP_TASK_SEED_TITLES.map((title, sortOrder) => ({
    title,
    sortOrder,
  }));
}

/** Ensure local template is non-empty (seeds defaults once, persists via prefs PUT). */
export function ensureDefaultTripTaskTemplate(): TripTaskTemplateItem[] {
  const profile = loadLocalUserPreferences().travelerPreferenceProfile;
  const existing = profile.defaultTripTaskTemplate ?? [];
  if (existing.length > 0) {
    return [...existing].sort((a, b) => a.sortOrder - b.sortOrder);
  }
  const seeded = seedDefaultTripTaskTemplate();
  patchTravelerPreferenceProfile({ defaultTripTaskTemplate: seeded });
  return seeded;
}

export function sortedTripTaskTemplate(
  items: TripTaskTemplateItem[] | null | undefined
): TripTaskTemplateItem[] {
  return [...(items ?? [])].sort((a, b) => a.sortOrder - b.sortOrder);
}

/** Build trip.taskItems from the user's default template (or seed). */
export function taskItemsFromDefaultTemplate(): TripTaskItem[] {
  const template = ensureDefaultTripTaskTemplate();
  return template.map((item, index) => ({
    id: crypto.randomUUID(),
    title: item.title,
    isDone: false,
    sortOrder: item.sortOrder ?? index,
  }));
}
